export class ValuesPurchaseRequest {
    public purchaseId: number = 0;
    public products: ValuesProducts[] = [];
}

export class ValuesProducts {
    public productId: number = 0;
    public collaboratorValues: CollaboratorsValue[] = [];
}

export class CollaboratorsValue {
    public collaboratorId: number = 0;
    public value: number = 0;
}
